// import

import clsx from 'clsx';
import {styled} from 'goober';
import type {ComponentProps} from 'react';

import type {PostNode, HomeMainNode} from 'libs/model';
import {Link} from 'modules/Link';
import {RelatedPosts} from 'modules/Post';
import {Type} from 'modules/Type';

// types

type Props = ComponentProps<typeof Block> &
HomeMainNode['meta']['postsRegion'] &
{posts: PostNode[]};

// component

export function HomePosts(props: Props) {
  const {posts, headline, subhead, buttonText, ...rest} = props;

  return (
    <Block {...rest} data-test="posts">
      <Type as="header" className="inner hp-header">
        <h1 className="hp-title">{headline}</h1>
        <h2 className="hp-subtitle">{subhead}</h2>
      </Type>

      <RelatedPosts className="hp-posts" nodes={posts} />

      <Type as="footer" className="inner hp-footer">
        <Link className={clsx('unstyled', 'hp-button')} href="/blog">
          {buttonText}
        </Link>
      </Type>
    </Block>
  );
}

// styles

const Block = styled('section')`
  padding: 9rem 1rem 6rem;
  position: relative;

  .inner {
    margin: 6rem auto 0;
    max-width: var(--bp-m);

    &:first-child {
      margin-top: 0;
    }
  }

  .hp-title {
    font-weight: 800;
    text-transform: uppercase;
    font-size: 3.5rem;
    line-height: 3.5rem;
    margin: 0;
    text-align: center;
    font-family: var(--font-body);
  }

  .hp-subtitle {
    font-weight: 400;
    font-size: 1.5rem;
    line-height: 2rem;
    text-align: center;
    margin: 0;
  }

  .hp-footer {
    text-align: center;
  }

  .hp-button {
    display: inline-block;
    width: min(27rem, 100%);
    border: 0.125rem solid var(--gray-20);
    line-height: 2rem;
    padding: 1rem 0.5rem;
    text-transform: uppercase;
    font-weight: 400;
    font-variation-settings: "wght" 400;
    letter-spacing: 0.25rem;
    border-radius: 0.25rem;
    transition:
      box-shadow 100ms linear,
      border-color 100ms linear,
      font-variation-settings 100ms linear;

    &:hover {
      border-color: var(--red);
      box-shadow:
        inset 0.125rem 0 0 var(--red),
        inset -0.125rem 0 0 var(--red),
        inset 0 0.125rem 0 var(--red),
        inset 0 -0.125rem 0 var(--red);
      font-variation-settings: "wght" 800;
    }
  }
`;
